import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Fab, Tooltip } from '@mui/material';
import React from 'react';

export default function WhatsAppButton() {
    const phoneNumber = '905315404669'; // 0531 540 4669 - Başında 90 ile Türkiye kodu
    const message = encodeURIComponent('Merhaba, Trendasist hakkında bilgi almak ve kurulum hakkında yardım almak adına yazıyorum.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <Tooltip title="WhatsApp ile İletişime Geçin" arrow placement="left">
            <Fab
                color="success"
                aria-label="whatsapp"
                sx={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000,
                    backgroundColor: '#25D366', // WhatsApp yeşili
                    '&:hover': {
                        backgroundColor: '#128C7E', // Hover durumunda koyu yeşil
                    },
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                }}
                onClick={() => window.open(whatsappUrl, '_blank')}
            >
                <WhatsAppIcon fontSize="large" />
            </Fab>
        </Tooltip>
    );
} 